import { useCallback, useEffect, useState } from 'react'
import { point, featureCollection } from '@turf/turf'
import { returnPinType, returnSource } from '../utility/geojson'
import { useChargerState, useMapState } from '../state/context'
import { useMap } from 'react-map-gl'
import styles from '../utility/styles'

/**
 *
 * @param {{point:[longitude:number,latitude:number], id:string, type:'fast'|'normal'}[]} pinsArray
 * @param {boolean} showNonTeslaOnly
 * @returns {GeoJSON.FeatureCollection<GeoJSON.Geometry>}
 */
export const useSource = (pinsArray, showNonTeslaOnly) => {
	const [source, setSource] = useState(null)

	useEffect(() => {
		if (Array.isArray(pinsArray) && pinsArray.length) {
			const filtered = pinsArray.filter(pin => pin?.sc_non_tesla)
			const updatedArray = returnPinType(showNonTeslaOnly ? filtered : pinsArray)
			const s = returnSource(updatedArray)
			setSource(s)
		}
	}, [pinsArray, setSource, showNonTeslaOnly])

	return source
}

/**
 *
 * @returns {{checkingLocation:boolean,showLocationModal:boolean}}
 */
export const useLocationState = () => {
	const [{ checkingLocation, showLocationModal }] = useMapState()

	return {
		checkingLocation,
		showLocationModal,
	}
}

/**
 *
 * @returns {string} url for the current zap
 */
export const useCurrentZap = () => {
	const [zap, setZap] = useState(null)
	const [{ zaps, activeZap }] = useChargerState()

	useEffect(() => {
		if (Array.isArray(zaps)) {
			if (activeZap) {
				// find the active zap from the zaps array
				const active = zaps.find(({ id }) => id === activeZap)
				if (Array.isArray(active?.media)) {
					// find the src for the active zap
					const z = active.media[0]?.url
					setZap(z)
				}
			} else {
				// zap is null
				setZap(null)
			}
		}
	}, [activeZap])

	return zap
}

/**
 *
 * @param {mapboxgl.FlyToOptions} defaultOptions
 */
export const useFlyTo = (defaultOptions = {}) => {
	const { chargerMap } = useMap()
	/**
	 *
	 * @param {[longitude:number,latitude:number]} center
	 * @param {mapboxgl.FlyToOptions} options
	 * @returns
	 */
	const flyTo = useCallback(
		(center, options = {}) =>
			chargerMap.flyTo({ center, ...{ ...defaultOptions, ...options } }),
		[defaultOptions, chargerMap]
	)

	return flyTo
}

export const useIsMobileDevice = (useTouch = false) => {
	if (useTouch) return !!window?.ontouchstart
	return window.matchMedia(styles.breakpoints.mobile).matches
}

/**
 * 
 * @param {string} searchTerm 
 * @returns 
 */
export const useIsBrowserAgent = searchTerm => {
	if (typeof searchTerm !== 'string') return false
	return navigator.userAgent.toLowerCase().search(searchTerm.toLowerCase()) > -1
}